import { Component, OnInit } from '@angular/core';
import { Role } from '../../model/auth/Role';
import { Region } from '../../model/location/Region';
import { School, SchoolGrade } from '../../model/location/School';
import { NotificationHandler } from '../../helper/notification.handler';
import { UrlHelper } from '../../helper/url.helper';
import { AuthService } from '../../service/auth.service';
import { UserService } from '../../service/user.service';
import { Router } from '@angular/router';
import { SchoolSelectResult } from '../school-select/school-select.component';
import { LocationService } from '../../service/location.service';

@Component({
  selector: 'school-modify-details',
  templateUrl: './school-modify-details.component.html',
  styleUrls: ['./school-modify-details.component.scss']
})
export class SchoolModifyDetailsComponent implements OnInit {

  roles = [Role.Teacher, Role.Student];

  gradeSelectDisabled = false;

  selectedGrade?: SchoolGrade;
  selectedRegion?: Region;
  selectedSchool?: School;

  dataLoaded = false;
  inProgress = false;

  constructor(private authService: AuthService,
              private userService: UserService,
              private locationService: LocationService,
              private router: Router) {
  }

  async ngOnInit(): Promise<void> {
    const user = await this.authService.getUser();
    if (user) {
      if (user.region) {
        this.selectedRegion = new Region(user.region, '');
      }
      this.selectedGrade = user.schoolGrade;

      if (user.schoolId) {
        this.loadSchoolDetails(user.schoolId);
      } else {
        this.dataLoaded = true;
      }
    }

    const session = await this.authService.getSession();
    this.gradeSelectDisabled = session.isTeacher();
  }

  private loadSchoolDetails(schoolId: string) {
    this.locationService.getSchoolDetails(schoolId).subscribe(school => {
      this.selectedSchool = school;
    }, error => {
      NotificationHandler.handleError($localize`:Notifications|School details fetch has failed message@@notifications-school-details-fetch-failed-error:School details fetch has failed`, error);
    }, () => this.dataLoaded = true);
  }

  schoolSelected(data: SchoolSelectResult) {
    this.selectedSchool = data ? data.school : undefined;
  }

  async cancelChange() {
    await this.router.navigate([UrlHelper.PROFILE_SCHOOL_DETAILS_PATH]);
  }

  async saveSelection() {
    if (!this.selectedRegion || !this.selectedSchool) return;
    this.inProgress = true;

    const updated = await this.authService.updateUserSchool(this.selectedSchool, this.selectedRegion, this.selectedGrade);
    if (updated) {
      const user = await this.authService.getUser();

      if (user) {
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        this.userService.reportUpdateUser(user.id).subscribe(async () => {
          if (this.selectedRegion) {
            await this.router.navigate([UrlHelper.PROFILE_SCHOOL_DETAILS_PATH]);
          } else {
            await this.router.navigate([UrlHelper.DEFAULT_AUTH_PATH], {replaceUrl: true});
          }
        }, error => {
          NotificationHandler.handleError($localize`:User Profile|User profile update report failed notification@@user-profile-report-failed-notification:Profile update report failed`, error);
          this.inProgress = false;
        });
      } else {
        await this.router.navigate([UrlHelper.SIGN_IN_PATH]);
      }
    } else {
      this.inProgress = false;
    }
  }
}
